import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import MenuBar from "gatsby-theme-wirehead-bulma/src/menubar"

const Header = ({ siteTitle }) => (
  <div className="headerbar">
    <div className="headerlogo">
    </div>
    <MenuBar siteTitle={siteTitle} endLinks={
      <Link to="/mail" className="navbar-item">
          &#9993; Mail
        </Link>
    }/>
  </div>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
